import { AdminSubRole, Role } from '@ypp-portal/models/user/role';
import React, { useEffect, useState } from 'react';
import AudienceCheckbox from './AudienceCheckbox';

export interface Audience {
  roles: Role[];
  adminSubroles: AdminSubRole[];
}

interface AudienceSelectorProps {
  onChange: (roles: Audience) => void;
}

const AudienceSelector: React.FC<AudienceSelectorProps> = ({ onChange }) => {
  const [selected, setSelected] = useState<Set<Role>>(new Set());
  const [selectedSub, setSelectedSub] = useState<Set<AdminSubRole>>(new Set());

  const options = [
    { label: 'Instructors', role: Role.Instructor },
    { label: 'Parents and Students', role: Role.Parent },
    { label: 'Applicants', role: Role.Applicant },
    { label: 'Administrative Accounts', role: Role.Admin },
  ];

  const subOptions = [
    { label: 'President', role: AdminSubRole.President },
    { label: 'Chief Of Staff', role: AdminSubRole.ChiefOfStaff },
    { label: 'Chief Financial Officer', role: AdminSubRole.CFO },
    { label: 'Chief Operating Officer', role: AdminSubRole.COO },
    { label: 'Chief Marketing Officer', role: AdminSubRole.CMO },
    { label: 'Chief Administrative Officer', role: AdminSubRole.CAO },
    { label: 'Director of Student Experience', role: AdminSubRole.DirectorOfSE },
    { label: 'Director of Human Resources', role: AdminSubRole.DirectorOfHR },
    { label: 'Technology', role: AdminSubRole.Tech },
    { label: 'Chapter Presidents', role: AdminSubRole.ChapterPresident },
  ];

  const addOrRemoveRole = (role: Role) => {
    setSelected((s) => {
      const copy = new Set(s);
      if (copy.has(role)) {
        copy.delete(role);
        return copy;
      } else {
        return copy.add(role);
      }
    });
  };

  const addOrRemoveSubRole = (role: AdminSubRole) => {
    setSelectedSub((s) => {
      const copy = new Set(s);
      if (copy.has(role)) {
        copy.delete(role);
        return copy;
      } else {
        return copy.add(role);
      }
    });
  };

  useEffect(() => {
    onChange({
      roles: Array.from(selected),
      adminSubroles: selected.has(Role.Admin) ? Array.from(selectedSub) : [],
    });
  }, [selected, selectedSub, onChange]);

  return (
    <div className='my-8'>
      <h1 className='font-semibold mb-2 text-xl'>Choose your audience:</h1>
      {options.map(({ label, role }) => (
        <AudienceCheckbox
          key={role}
          label={label}
          role={role}
          onChange={() => addOrRemoveRole(role)}
        />
      ))}
      {selected.has(Role.Admin) ? (
        <div className='ml-4'>
          {subOptions.map(({ label, role }) => (
            <AudienceCheckbox
              key={role}
              label={label}
              role={role}
              onChange={() => addOrRemoveSubRole(role)}
            />
          ))}
        </div>
      ) : null}
    </div>
  );
};

export default AudienceSelector;
